import { ExerciseMetric } from "types";

const weightMetric: ExerciseMetric = {
  isDefault: false,
  isPbEnabled: true,
  displayMetadata: { imperial: { decimals: null, unit: "Pound" }, metric: null },
  name: "Weight",
  field: "weight",
  unitOfMeasure: "Kilogram",
  sortType: 1,
};
export default weightMetric;
